import React from "react";

/**
 * ProSe.Claims wordmark. Rendered as inline SVG so it stays razor-sharp at any size,
 * has a transparent background, and needs no external asset.
 * Height is controlled by the `size` prop (in px). Width scales proportionally.
 *
 * Layout:
 *   PROSE.   -> "PRO" in slate-900, "SE." in orange-600, kerned as one word
 *   CLAIMS   -> slate-900, wide tracked, sits beneath PROSE.
 */
export default function ProseLogo({ size = 44, className = "", title = "ProSe.Claims" }) {
  const w = size * 2.35; // preserves the wordmark aspect ratio (extra room for the trailing period)
  return (
    <svg
      viewBox="0 0 470 200"
      width={w}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={className}
    >
      <title>{title}</title>
      {/* Top line: PROSE. rendered as ONE text so kerning is perfect,
          with color switching via <tspan> at the "SE." boundary. */}
      <text
        x="0"
        y="118"
        fontFamily='"Archivo Black","Arial Black",Impact,system-ui,sans-serif'
        fontWeight="900"
        fontSize="118"
        letterSpacing="-2"
        fill="#0f172a"
      >
        PRO<tspan fill="#EA580C">SE.</tspan>
      </text>
      {/* Bottom line: CLAIMS in slate-900, wide tracking */}
      <text
        x="4"
        y="188"
        fontFamily='"Archivo","Arial",system-ui,sans-serif'
        fontWeight="800"
        fontSize="52"
        letterSpacing="18"
        fill="#0f172a"
      >
        CLAIMS
      </text>
    </svg>
  );
}
